import { Avatar, Typography } from '@mui/material';
import { calculateAvatarColor } from './avatarColor';

interface Props {
  name: string;
  size?: 'small' | 'normal';
  initials?: string | null;
}

export default function ({
  name,
  size = 'normal',
  initials: userInitials,
}: Props) {
  let width = 48;
  let typoVariant = 'body';

  if (size === 'small') {
    width = 32;
    typoVariant = 'textMd';
  }
  const getInitials = (name: string) => {
    const arrayName = name.split(' ');
    return (arrayName[0]?.[0] ?? '') + (arrayName[1]?.[0] ?? '');
  };

  const initials = userInitials ?? getInitials(name);

  const color = calculateAvatarColor(initials);

  return (
    <Avatar sx={{ bgcolor: color, width, height: width }}>
      <Typography variant={typoVariant as any}>
        {initials.toUpperCase()}
      </Typography>
    </Avatar>
  );
}
